<template>
  <div class="container">
    <generic-uploader
      ref="generic_uploader"
      :idle_label="$t('drop pdf files here or click to upload')"
      endpoint_url="/document-sign/document/file"
      :allow_multiple="true"
      @error="error_uploading"
      @success="success_uploading"
    />
    <div class="title is-6" v-if="pages && pages.length">{{ $t("pages") }}</div>
    <div class="grid is-col-min-7">
      <draggable v-model="pages" tag="transition-group" @change="move">
        <template #item="{ element }">
          <div class="cell" key="uuid">
            <div class="card">
              <div class="card-image">
                <figure class="image is-4by3">
                  <v-lazy-image
                    :src="api_host + '/drive/static' + element.static_file_path"
                  />
                </figure>
              </div>
              <div class="card-content">
                <div class="media">
                  <div class="media-content">
                    <p class="title is-6">{{ element.file_name }}</p>
                    <p class="subtitle is-6 mb-0">
                      {{ $t("original document page number") }}
                      {{ element.page }}
                    </p>
                  </div>
                </div>
              </div>
              <footer class="card-footer">
                <div class="card-footer-item">
                  <span v-if="element.sign_areas && element.sign_areas.length"
                    ><span>{{ element.sign_areas.length }}</span>
                    <span class="icon"> <i class="fa fa-edit"></i> </span
                  ></span>
                  <span v-else>
                    <span>0</span>
                    <span class="icon"> <i class="fa fa-edit"></i> </span>
                  </span>
                </div>
                <div class="card-footer-item">
                  <div
                    class="button is-primary is-small"
                    :data-tooltip="$t('configure signatures')"
                    @click="configure_signatures(element)"
                  >
                    <span class="icon">
                      <i class="fa fa-edit"></i>
                    </span>
                    <!-- <span>{{ $t("configure signatures") }}</span> -->
                  </div>
                </div>
                <div class="card-footer-item">
                  <div
                    class="button is-danger is-small"
                    :data-tooltip="$t('delete page')"
                    @click="delete_page(element)"
                  >
                    <span class="icon">
                      <i class="fa fa-trash"></i>
                    </span>
                    <!-- <span>{{ $t("delete") }}</span> -->
                  </div>
                </div>
              </footer>
            </div>
          </div>
        </template>
      </draggable>
    </div>
    <signatures-modal ref="signatures_modal" @success="set_signature_areas" />
  </div>
</template>

<script>
import { generate_error_message_text, api_host } from "@/utils";
import GenericUploader from "@/components/generic_uploader/Index.vue";
import VLazyImage from "v-lazy-image";
import draggable from "vuedraggable";
import SignaturesModal from "../../signing_profile_datatable/signatures_modal/Index.vue";

export default {
  name: "DocumentUpload",
  components: { GenericUploader, VLazyImage, draggable, SignaturesModal },
  data() {
    return {
      api_host,
      pages: [],
    };
  },
  methods: {
    error_uploading(error) {
      let v = this;
      v.$emit("error", generate_error_message_text(error));
    },
    success_uploading(data) {
      let v = this;
      let _data = JSON.parse(data.serverId).map((i, idx) => {
        return i;
      });
      v.pages = v.pages.concat(_data);
    },
    clear() {
      let v = this;
      v.pages = [];
      v.$refs.generic_uploader.clear();
    },
    move(/* movement */) {
      //   let v = this;
      //   let old_index = movement.moved.oldIndex;
      //   let new_index = movement.moved.newIndex;
      //   let target_page = v.pages[old_index];
    },
    get_pages() {
      let v = this;
      return v.pages;
    },
    delete_page(page) {
      let v = this;
      v.pages = v.pages.filter((i) => i.uuid !== page.uuid);
    },
    configure_signatures(page) {
      let v = this;
      let pg = JSON.parse(JSON.stringify(page));
      // console.log("configure_signatures", pg);
      v.$refs.signatures_modal.show_modal(pg);
    },
    set_signature_areas(obj) {
      let v = this;
      let page_uuid = obj.page_uuid;
      let signature_areas = obj.sign_areas;
      let page = v.pages.find((i) => i.uuid === page_uuid);
      // console.log(page, signature_areas);
      page.sign_areas = signature_areas;
    },
    set_signing_profile(signing_profile) {
      let v = this;
      if (
        signing_profile &&
        signing_profile.settings &&
        signing_profile.settings.pages
      ) {
        let pages = signing_profile.settings.pages;
        pages.map((page, pidx) => {
          let _page = v.pages[pidx];
          if (_page) {
            _page.sign_areas = page.sign_areas;
          }
        });
      }
    },
  },
  mounted() {
    // let v = this;
    // setTimeout(() => {
    //   v.pages = [];
    // }, 1000);
  },
};
</script>

<style scoped></style>
